var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchResult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 170,
    viewBox: "0 0 329 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.208 5.92966C322.824 5.92966 329 12.0968 329 19.7013C329 27.3059 322.824 33.473 315.208 33.473H236.406C244.022 33.473 250.198 39.6402 250.198 47.2447C250.198 54.8492 244.022 61.0164 236.406 61.0164H279.746C287.362 61.0164 293.538 67.1835 293.538 74.7881C293.538 82.3926 287.362 88.5598 279.746 88.5598H259.7C250.099 88.5598 242.313 94.7269 242.313 102.331C242.313 107.401 246.255 111.989 254.133 116.103C261.749 116.103 267.925 122.27 267.925 129.875C267.925 137.479 261.749 143.646 254.133 143.646H90.6227C83.007 143.646 76.8307 137.479 76.8307 129.875C76.8307 122.27 83.007 116.103 90.6227 116.103H13.792C6.17625 116.103 0 109.936 0 102.331C0 94.7269 6.17625 88.5598 13.792 88.5598H92.594C100.21 88.5598 106.386 82.3926 106.386 74.7881C106.386 67.1835 100.21 61.0164 92.594 61.0164H43.3401C35.7244 61.0164 29.5481 54.8492 29.5481 47.2447C29.5481 39.6402 35.7244 33.473 43.3401 33.473H122.142C114.526 33.473 108.35 27.3059 108.35 19.7013C108.35 12.0968 114.526 5.92966 122.142 5.92966H315.208ZM315.208 61.0093C322.824 61.0093 329 67.1765 329 74.781C329 82.3855 322.824 88.5527 315.208 88.5527C307.592 88.5527 301.416 82.3855 301.416 74.781C301.416 67.1765 307.592 61.0093 315.208 61.0093Z",
    fill: "#C7E2CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.798 133.797C181.245 133.797 210.793 104.293 210.793 67.8987C210.793 31.5046 181.245 2 144.798 2C108.35 2 78.802 31.5046 78.802 67.8987C78.802 104.293 108.35 133.797 144.798 133.797Z",
    fill: "white",
    stroke: "#52705A",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.218 119.027C137.685 119.665 141.21 119.997 144.79 120.026C173.622 120.026 196.994 96.6882 196.994 67.8986C196.994 39.1091 173.622 15.7716 144.79 15.7716C137.387 15.7716 130.339 17.3152 123.957 20.0908C112.867 24.9197 103.776 33.4801 98.2878 44.1859C94.6431 51.3018 92.5796 59.3666 92.5796 67.9057C92.5796 75.6589 94.2743 83.0086 97.3093 89.6218C99.4791 94.3446 102.33 98.6849 105.748 102.515",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.218 119.027C137.685 119.665 141.21 119.997 144.79 120.026C173.622 120.026 196.994 96.6882 196.994 67.8986C196.994 39.1091 173.622 15.7716 144.79 15.7716C137.387 15.7716 130.339 17.3152 123.957 20.0908C112.867 24.9197 103.776 33.4801 98.2878 44.1859C94.6431 51.3018 92.5796 59.3666 92.5796 67.9057C92.5796 75.6589 94.2743 83.0086 97.3093 89.6218C99.4791 94.3446 102.33 98.6849 105.748 102.515",
    stroke: "#63936C",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.888 108.371C116.122 111.805 120.901 114.595 126.077 116.577",
    stroke: "#63936C",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.973 120.026L210.793 131.829L198.973 120.026Z",
    fill: "#F3F7FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M198.973 120.026L210.793 131.829",
    stroke: "#52705A",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.886 129.917C205.156 133.642 205.156 139.674 208.886 143.399L230.726 165.207C234.456 168.931 240.497 168.931 244.227 165.207C247.957 161.482 247.957 155.45 244.227 151.725L222.387 129.917C218.657 126.193 212.616 126.193 208.886 129.917Z",
    fill: "white",
    stroke: "#52705A",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M218.671 133.797L240.341 155.436",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.991 45.2693C131.991 68.0828 150.513 86.5772 173.36 86.5772C177.849 86.5772 182.167 85.8621 186.216 84.5451C179.607 100.915 163.553 112.471 144.791 112.471C120.135 112.471 100.146 92.5107 100.146 67.8917C100.146 45.5808 116.554 27.1006 137.983 23.8293C134.175 30.0815 131.984 37.4169 131.984 45.2693H131.991Z",
    fill: "#D8EFDD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M145.783 31.5047C143.273 31.5047 140.826 31.7525 138.451 32.2198M131.289 34.4077C117.816 40.065 108.35 53.3694 108.35 68.8829",
    stroke: "#63936C",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M250.538 68.4439H234.435M262.997 53.1428H229.159M276.789 53.1428H272.414",
    stroke: "#A3C6AC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2355 111.72H57.1319M64.0243 94.4508H30.1862M18.713 94.4508H10.3953",
    stroke: "#A3C6AC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchResult);
export default __webpack_public_path__ + "static/media/searchResult.4f8b0b4880aa5f4d4c41f52be1d849e5.svg";
export { ForwardRef as ReactComponent };